import progress from './middleware/progress';
import updateSection from './middleware/update-section';
import collapseSidebar from './middleware/collapse-sidebar';

const globalMiddleware = [ progress, updateSection, collapseSidebar ];

/**
 * Handles the `after()` method in middleware.
 *
 * @returns {void}
 */
export default (to, from) => {
	const middleware = globalMiddleware.concat(to.meta.middleware || []);
	const context = {
		to, from
	};

	for (const singleMiddleware of middleware) {
		singleMiddleware.after({
			...context
		});
	}
};
